export default "__VITE_ASSET__DgUMA3Rq__"